import { Button, Radio, Select, Space, Switch, Typography } from "antd";
import {
  CheckOutlined,
  CloseOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";

import Clock from "./components/Clock";
import CalendarIssue from "../../components/CalendarIssue";
import { useWorkers } from "context/providers/workers";
import { useCalendarIssues } from "../../context";

const Header = () => {
  const {
    origin_source,
    events,
    tasks,
    worker_id,
    view_type,
    calendar_date,
    show_night_hours,
    setViewType,
    setShowNightHours,
    setCalendarDate,
    setWorkerId,
  } = useCalendarIssues();
  const { workers_list_options } = useWorkers();
  const is_same_day = dayjs(calendar_date).isSame(dayjs(), "day");
  const date_today = dayjs().format("DD MMMM YYYY");
  return (
    <div className="calendar__main-header">
      <div className="header-box header-box--left">
        <div className="header-box__time">
          <Clock />
        </div>
        <div className="header-box__date-group">
          <h2 className="header-box__date">
            Dzisiaj:{" "}
            {is_same_day ? (
              date_today
            ) : (
              <Button
                type="link"
                htmlType="button"
                onClick={() => setCalendarDate(dayjs())}
                iconPosition="end"
                icon={<ArrowLeftOutlined />}
              >
                {date_today}
              </Button>
            )}
          </h2>
        </div>
        <div className="header-box__worker">
          <Select
            style={{ minWidth: 200 }}
            value={worker_id}
            placeholder="Wybierz pracownika"
            filterOption={false}
            onChange={(id) => setWorkerId(id || null)}
            options={[
              { label: "Wszyscy", value: null },
              ...(workers_list_options || []),
            ]}
          />
        </div>
      </div>
      <div className="header-box header-box--center">
        <CalendarIssue />
        <Radio.Group
          value={view_type}
          buttonStyle="solid"
          onChange={({ target: { value } }) => setViewType(value)}
        >
          <Radio.Button value="day">Dzienny</Radio.Button>
          <Radio.Button value="week">Tygodniowy</Radio.Button>
          <Radio.Button value="month">Miesięczny</Radio.Button>
        </Radio.Group>
        {view_type !== "month" && (
          <Space className="header-box__toggle">
            <Typography.Text>Pokaż godziny nocne</Typography.Text>
            <Switch
              checkedChildren={<CheckOutlined />}
              unCheckedChildren={<CloseOutlined />}
              value={show_night_hours}
              onChange={(value) => setShowNightHours(value)}
            />
          </Space>
        )}
      </div>
      <div className="header-box header-box--right">
        <p className="header-box__source">Źródło: {origin_source}</p>

        <div className="header-box__counts">
          <p>Ilość zgłoszeń: {events?.length || 0}</p>
          <p>Ilość priorytetów: {tasks?.length || 0}</p>
        </div>
      </div>
    </div>
  );
};

export default Header;
